import React from "react";
import { useDispatch } from "react-redux";
import { Button } from "../../../../components/button/Button";
import { generateDeeplink } from "../../../../components/deeplinkDialog/deeplinkDialog.actions";
import { Icon } from "../../../../components/icon/Icon";
import { FormattedMessage } from "react-intl";

import "./InviteremodeDevice.scss";

export const InviteRemoteDevice = ({ className }) => {
  const dispatch = useDispatch();

  function handleGenerateLinkClick() {
    dispatch(generateDeeplink());
  }

  return (
    <div className={className}>
      <Button
        className="invite-remote-device"
        onClick={handleGenerateLinkClick}
        data-testid="invite-remote-device-button"
        color={"secondary"}
      >
        <Icon icon="fa-regular fa-link" />
        <span>
          <FormattedMessage id="invite_remote_device" />
        </span>
      </Button>
    </div>
  );
};
